import { ITerm } from './TOS';

export const generalTermsAndConditionsOfSale: ITerm[] = [
  {
    tag: 'h1',
    text: 'General Terms and Conditions',
  },
  {
    tag: 'h2',
    text: 'Last updated: MAY 06, 2024',
  },
  {
    tag: 'h2',
    text: 'I. Your Relationship with Us and Acceptance of the Terms',
  },
  {
    tag: 'p',
    text: 'Welcome to LouiseBot (the “Platform”), provided by Pink Swan, a Switzerland-based company with commercial registration number CH-660.0.157.021-1 (the “Company”, “we”, or “our”).',
  },
  {
    tag: 'p',
    text: 'LouiseBot offers users an interface to interact with existing artificial intelligence systems, such as OpenAI, IBM Watson, and others. While we don’t offer AI services directly, we make it easier for users to access and utilize these AI services through our Platform. You are reading the terms of service (the “Terms”) that govern the relationship and agreement between you and us and set forth the terms and conditions by which you may access and use the Platform and our associated websites, services, applications, products, and content (collectively, the “Services”).',
  },
  {
    tag: 'p',
    text: 'For the purposes of these Terms, “you” refers to the user of the Services.',
  },
  {
    tag: 'h3',
    text: 'User Representations',
  },
  {
    tag: 'p',
    text: 'By accessing our Services or using our Services, you confirm that you can form a binding contract with us, that you accept these Terms, and that you agree to comply with them. You understand and agree that we will treat your use of the Services as acceptance of the Terms from that point onwards.',
  },
  {
    tag: 'p',
    text: 'i) You are at least 12 years of age, or the statutory age of majority in your country of nationality and residence, whichever is higher; ii) You are not restricted from using the Services by law, contract, or by us; iii) You fully agree with the terms and conditions set forth in the Terms; iv) Where necessary, your legal guardian has reviewed and agreed to these Terms and is responsible for any liabilities arising herefrom.',
  },
  {
    tag: 'h2',
    text: 'II. Changes to the Terms',
  },
  {
    tag: 'p',
    text: 'Owing to the dynamic nature of technology, market conditions, and regulations, Pink Swan retains the right to amend or revise these Terms at its discretion. Any updated version of the Terms becomes effective upon its publication on LouiseBot. Your sustained use of the Services post any changes implies your acknowledgment and acceptance of the modified Terms.',
  },
  {
    tag: 'p',
    text: 'If you disagree with any alterations to the Terms, your exclusive remedy is to cease using our Services.',
  },
  {
    tag: 'h2',
    text: 'III. USER RIGHTS AND LICENSES',
  },
  {
    tag: 'h3',
    text: '1. Rights to Access the Services',
  },
  {
    tag: 'p',
    text: 'A. LouiseBot offers a platform that integrates various artificial intelligence models, including but not limited to OpenAI, IBM Watson, etc., allowing users to engage in interactive sessions with AI-powered bots. Our Services could be accessed through our website, app, or other affiliated platforms, and might sometimes incorporate third-party services.',
  },
  {
    tag: 'p',
    text: 'B. Given your adherence to these Terms and relevant legal stipulations, Pink Swan provides you with a conditional, limited, revocable, non-exclusive, non-transferable, and non-sublicensable license to use our Services, strictly for individual, non-business purposes.',
  },
  {
    tag: 'ul',
    items: [
      '- Access or use the Services if you are not fully able and legally competent to agree to these Terms or are not authorized to use the Services by your parent or legal guardian;',
      '- Access or use the Services for any purpose other than as expressly permitted by the Terms;',
      '- Make unauthorized copies, modify, adapt, translate, reverse engineer, disassemble, decompile or create any derivative works of the Services or any content included therein, including any files, tables or documentation (or any portion thereof) or determine or attempt to determine any source code, algorithms, methods or techniques embodied by the Services or any derivative works thereof;',
      '- Distribute, license, transfer, or sell, in whole or in part, any of the Services or any derivative works thereof;',
      '- Market, rent or lease the Services for a fee or charge, or use the Services to advertise or perform any commercial solicitation;',
      '- Use the Services, without our express written consent, for any commercial or unauthorized purpose, including communicating or facilitating any commercial advertisement or solicitation or spamming;',
      '- Interfere with or attempt to interfere with the proper working of the Services, disrupt our website or any networks connected to the Services, or bypass any measures we may use to prevent or restrict access to the Services;',
      '- Incorporate the Services or any portion thereof into any other program or product. In such case, we reserve the right to refuse to provide any Services, terminate accounts or limit access to the Services in our sole discretion;',
      '- Use automated scripts to collect information from or otherwise interact with the Services;',
      '- Impersonate any person or entity, or falsely state or otherwise misrepresent you or your affiliation with any person or entity, including giving the impression that any content you upload, post, transmit, distribute or otherwise make available emanates from the Services;',
      '- Intimidate or harass another, or promote sexually explicit material, violence or discrimination based on race, sex, religion, nationality, disability, sexual orientation or age;',
      '- Use or attempt to use another’s account, service or system without authorization from us, or create a false identity on the Services;',
      '- Use the Services in a manner that may create a conflict of interest or undermine the purposes of the Services, such as trading reviews with other users or writing or soliciting fake reviews;',
      '- Use the Services to upload, transmit, distribute, store or otherwise make available in any way: files that contain viruses, trojans, worms, logic bombs or other material that is malicious or technologically harmful;',
      '- Provide any answers, responses, comments, opinions, analysis or recommendations that you are not properly licensed or otherwise qualified to provide; or material that, in the sole judgment of the Company, is objectionable or which restricts or inhibits any other person from using the Services, or which may expose the Company, the Services or its users to any harm or liability of any type of attack, hack, interfere with other user’s use of, reverse-engineer, disassemble, attempt to derive the source code of, the Service or any part thereof;',
      '- Use the Service in a way that is unlawful, illegal or unauthorized, or advocates, promotes or assists any unlawful act;',
      '- Use the Service in a way that is defamatory of any other person;',
      '- Use the Service in a way that is obscene or offensive;',
      '- Content that may reasonably be considered to be illegal, defamatory, libelous, immoral, harmful, misleading, deceptive, fraudulent, indecent, hateful, racially or religiously biased or offensive, slanderous, obscene, pornographic, sexually explicit, or that encourage anyone to violate any local, state, national or international law.',
    ],
  },
  {
    tag: 'p',
    text: 'In addition, you are not allowed to upload, enter, create, generate via the Service the following types of content:',
  },
  {
    tag: 'ul',
    items: [
      '- Content that expresses, incites, or promotes hate based on identity;',
      '- Content that intends to harass, threaten, or bully an individual;',
      '- Content that promotes or glorifies violence or celebrates the suffering or humiliation of others;',
      '- Content that promotes, encourages, or depicts acts of self-harm, such as suicide, cutting, and eating disorders;',
      '- Content meant to arouse sexual excitement, such as the description of sexual activity, or that promotes sexual services (excluding sex education and wellness);',
      '- Content attempting to influence the political process or to be used for campaigning purposes;',
      'unsolicited bulk contents;',
      '- Content that is false or misleading, such as attempting to defraud individuals or spread disinformation;',
      '- Content that attempts to generate ransomware, keyloggers, viruses, or other software intended to impose some level of harm;',
      '- Content that may reasonably be considered to be illegal, defamatory, libelous, immoral, harmful, misleading, deceptive, fraudulent, indecent, hateful, racially or religiously biased or offensive, slanderous, obscene, pornographic, sexually explicit, or that encourage anyone to violate any local, state, national or international law.',
    ],
  },
  {
    tag: 'p',
    text: 'We do not and cannot pre-screen or monitor all content. Nevertheless, our representatives may monitor content submission through the Service, and you hereby provide irrevocable consent to such monitoring. You acknowledge and agree that you have no expectation of privacy concerning the submission of any content. We have the right, but not the obligation, in our sole discretion to edit, modify, and refuse to post or remove any content.',
  },
  {
    tag: 'p',
    text: 'In addition to the above, your access to and use of the Services must, at all times, be compliant with our rules, policies and procedures we may publish on our Services from time to time.',
  },
  {
    tag: 'p',
    text: 'The Company reserves the right, at any time and without prior notice, to remove or disable access to content at its discretion for any reason or no reason.',
  },
  {
    tag: 'h3',
    text: '2. License of the App',
  },
  {
    tag: 'p',
    text: 'A. LouiseBot encompasses integrated software elements which might contain copyrighted content. The App we provide you is licensed and not sold to you. All rights in the App not explicitly granted to you in these Terms remain with Pink Swan.',
  },
  {
    tag: 'p',
    text: 'B. Subject to your compliance with these Terms and pertinent laws, Pink Swan extends a conditional, limited, revocable, non-exclusive, non-transferable, non-sublicensable license to you to download, install, and utilize the App on your devices for personal, non-business usage.',
  },
  {
    tag: 'p',
    text: 'C. Except as expressly provided in the Terms, you shall not rent, sell, transfer, redistribute or sublicense the App. If you sell your computing device to a third party, you must remove the App from such device, or at least logout and erase all records in relation to your use (and your user account with us, if any) of the App.',
  },
  {
    tag: 'p',
    text: 'D. You shall not make use of errors, bugs or defects of the App, and shall not develop, distribute, disseminate or use any program, software or scripts which may cast detriment to us or the App.',
  },

  {
    tag: 'h3',
    text: '3. Use of Data',
  },
  {
    tag: 'p',
    text: 'You agree that Pink Swan may collect and use technical data and related information, including but not limited to technical information about your device, system, and network access. This information is gathered periodically to facilitate the provision of the Services, including customer service and technical support. Pink Swan may use this information to improve its products or to provide services to you or third parties, as long as it does not personally identify you.',
  },
  {
    tag: 'h5',
    text: 'Google User Data.',
  },
  {
    tag: 'p',
    text: 'When you log in to LouiseBot using your Google account, we may collect certain information from your Google profile, such as your name, email address, and profile picture. This data is used to personalize your experience within LouiseBot and to provide you with relevant services.',
  },
  {
    tag: 'p',
    text: 'We do not share your Google user data with any third parties, except when required by law or when necessary to provide the services you have requested. Your Google user data is securely stored on our servers and is only accessible to authorized personnel.',
  },
  {
    tag: 'p',
    text: "We will only use your Google user data in accordance with our privacy policy and in alignment with the permissions you grant us when connecting your Google account to LouiseBot. You can revoke LouiseBot's access to your Google account at any time through your Google account settings.",
  },
  {
    tag: 'h5',
    text: 'Apple User Data.',
  },
  {
    tag: 'p',
    text: 'When you log in to LouiseBot using your Apple account, we may collect certain information from your Apple profile, such as your name, email address, and profile picture. This data is used to personalize your experience within LouiseBot and to provide you with relevant services.',
  },
  {
    tag: 'p',
    text: 'We do not share your Apple user data with any third parties, except when required by law or when necessary to provide the services you have requested. Your Apple user data is securely stored on our servers and is only accessible to authorized personnel.',
  },
  {
    tag: 'p',
    text: "We will only use your Apple user data in accordance with our privacy policy and in alignment with the permissions you grant us when connecting your Apple account to LouiseBot. You can revoke LouiseBot's access to your Apple account at any time through your Apple account settings.",
  },
  {
    tag: 'p',
    text: 'LouiseBot uses Sign in with Apple, which provides a secure and private way to log in to our service. When you use Sign in with Apple, your Apple ID is protected and you have control over the information that is shared with LouiseBot. Apple does not track or profile you when you use Sign in with Apple to access LouiseBot.',
  },
  {
    tag: 'p',
    text: 'We are committed to protecting your privacy and ensuring the security of your Apple user data. If you have any questions or concerns about how we handle your data, please refer to our privacy policy or contact our support team.',
  },
  {
    tag: 'h3',
    text: '4. Limitations on Permissions and Rights',
  },
  {
    tag: 'p',
    text: 'The permissions and rights granted to you in these Terms are limited to those expressly stated. No other licenses or rights, whether implied, by estoppel, or otherwise, are granted to you',
  },
  {
    tag: 'p',
    text: 'You acknowledge and agree that, except for the licenses and rights explicitly provided in these Terms, Pink Swan retains all rights, title, and interest in and to the LouiseBot platform, the Services, and all intellectual property rights therein. Nothing in these Terms shall be construed as granting you any rights or licenses to use any trademarks, logos, domain names, or other brand features of Pink Swan or its affiliates.',
  },
  {
    tag: 'p',
    text: 'Any use of the Services or the LouiseBot platform not expressly permitted by these Terms is strictly prohibited and may constitute a violation of intellectual property rights, unfair competition laws, or other applicable laws and regulations. Pink Swan reserves the right to take any and all actions necessary to enforce its rights and protect its interests, including but not limited to legal proceedings and termination of your access to the Services.',
  },
  {
    tag: 'p',
    text: "By using the Services, you agree not to engage in any activity that may infringe upon, misappropriate, or otherwise violate Pink Swan's intellectual property rights or those of any third parties. If you believe that your rights have been violated by any content or materials available through the Services, please contact us immediately at contact@louisebot.com.",
  },
  {
    tag: 'h3',
    text: '5. Your Account',
  },
  {
    tag: 'p',
    text: 'A. You may log in with a third-party account before using our Services.',
  },
  {
    tag: 'p',
    text: 'B. When accessing certain parts of the Services, you may be prompted to provide us with specific information or log in with an existing Account. Ensure that all information provided is accurate, current, and complete, and update it promptly if it changes.',
  },
  {
    tag: 'p',
    text: 'C. Choose a unique nickname for your account. Pink Swan reserves the right to restrict certain combinations for legal, compliance, or other reasons.',
  },
  {
    tag: 'p',
    text: 'D. You are responsible for maintaining the confidentiality of your login credentials. Notify us immediately if you suspect any unauthorized use of your Account.',
  },
  {
    tag: 'p',
    text: "E. While you have the right to use your Account, Pink Swan retains its ownership. Unauthorized transfers or uses of the Account are prohibited. You're responsible for all activities linked to your Account, even if not conducted by you.",
  },
  {
    tag: 'p',
    text: 'F. Pink Swan may suspend, terminate, or reclaim your Account for valid reasons, such as inactivity or resource constraints.',
  },
  {
    tag: 'h3',
    text: '6. In-App Purchase',
  },
  {
    tag: 'p',
    text: 'Users can access additional features through in-app purchases. Prices are subject to change, and any adjustments will be effective immediately.',
  },
  {
    tag: 'h3',
    text: '7. Proper Usage of the Services',
  },
  {
    tag: 'p',
    text: 'Your access to and use of the Services require compliance with certain guidelines.',
  },
  {
    tag: 'p',
    text: "Pink Swan provides a tool for users to interact with various AI services. Each user is accountable for their actions within LouiseBot. While Pink Swan doesn't monitor user content, we expect all users to maintain respectful and legitimate behavior.",
  },
  {
    tag: 'h4',
    text: '1. Guidelines for Users:',
  },
  {
    tag: 'ul',
    items: [
      '- Promote and share LouiseBot with friends and colleagues;',
      '- Maintain courteous communication with other users;',
      '- Build connections for an enhanced experience;',
      '- Provide constructive feedback and comments.',
    ],
  },
  {
    tag: 'h4',
    text: '2. Consequences of Misuse of the Services',
  },
  {
    tag: 'p',
    text: "A. If you violate applicable laws, regulations, these Terms, or any other agreements or conditions associated with Pink Swan's LouiseBot, we reserve the right, in our discretion and in accordance with relevant rules, to take one or more countermeasures or penalties appropriate for your violation, including but not limited to:",
  },
  {
    tag: 'ul',
    items: [
      '- Removal of non-compliant content;',
      '- Restricting or terminating your access to certain aspects, features, or functions of LouiseBot;',
      '- Suspension or termination of your Account, and/or the denial of future services;',
      '- Public notices to address and condemn your violation.',
    ],
  },
  {
    tag: 'p',
    text: 'B. Multiple or repeated violations, or cases of severe misconduct, may lead to more significant consequences, as we reasonably determine.',
  },
  {
    tag: 'p',
    text: 'C. You agree to indemnify and hold Pink Swan, its affiliates, and each of their respective officers, directors, employees, agents, and advisors harmless from any loss, liability, claim, demand, damages, costs, and expenses, including reasonable attorney’s fees, related to or arising from:',
  },
  {
    tag: 'ul',
    items: [
      '- Your use and access of LouiseBot;',
      '- Any interactions or outputs generated through the use of the underlying AI services via LouiseBot;',
      '- Your breach of any term of these Terms;',
      '- Violations of any third-party rights, including, but not limited to copyrights, property rights, privacy rights, or third-party agreements;',
      '- Any content or information in your Account or any other content you transmit, use, store, or share through LouiseBot.',
    ],
  },
  {
    tag: 'h2',
    text: 'IV. INTELLECTUAL PROPERTY RIGHTS',
  },
  {
    tag: 'h4',
    text: 'Ownership of Platform Materials',
  },
  {
    tag: 'p',
    text: 'All rights, titles, and interests in the materials part of LouiseBot (including but not limited to designs, text, graphics, and other files) (“Platform Materials”) are owned by Pink Swan or its third-party licensors. Unauthorized use of Platform Materials is prohibited. You agree not to modify, copy, distribute, or exploit the Platform Materials without explicit written consent from Pink Swan. You acknowledge no ownership rights by using LouiseBot or accessing any Platform Materials on it. All rights not explicitly granted by these Terms are reserved by Pink Swan and its licensors.',
  },
  {
    tag: 'p',
    text: "You understand that the content provided on LouiseBot is for general information. It's your responsibility to seek professional advice before acting upon any information obtained through our Services. We don't guarantee the accuracy, completeness, or timeliness of any content. Any third-party links are for your convenience, and we're not responsible for their content.",
  },
  {
    tag: 'p',
    text: "We have no obligation to monitor, review, or edit any content on LouiseBot, including user interactions. Your interactions are at your own risk, and you're responsible for ensuring they don't violate any third-party rights or agreements.",
  },
  {
    tag: 'p',
    text: 'We implement reasonable measures to promptly remove any infringing material from our services upon becoming aware of such infringement.',
  },
  {
    tag: 'h4',
    text: 'User Content',
  },
  {
    tag: 'p',
    text: "You may supply, transmit, or upload content like data, questions, or text when using our services (referred to as 'Input Content'). In return, you will receive content generated by the artificial intelligence services you choose ('Output Content'). Both 'Input' and 'Output' contents are jointly termed 'User Content'. You are only permitted to supply User Content in accordance with this agreement and relevant laws.",
  },
  {
    tag: 'p',
    text: 'You affirm that you possess the rights to the Input Content and have all the necessary permissions to supply and license this content in line with this agreement. You confirm your legal standing in providing such content and adhering to this agreement within the applicable jurisdiction.',
  },
  {
    tag: 'p',
    text: "Upon transmitting the Input Content, you grant us a non-exclusive, irrevocable, royalty-free, perpetual license, with the right to sublicense, to use and adapt the content to improve and operate our current and future services, including training AI algorithms. This use is worldwide and doesn't require any further notice or compensation.",
  },
  {
    tag: 'p',
    text: 'Your use of our services and any content you provide is at your sole discretion and risk. You are fully accountable for the content you supply, ensuring it adheres to all applicable laws and this agreement. We are not responsible for any User Content or potential copyright issues that might arise from your use.',
  },
  {
    tag: 'p',
    text: 'You must refrain from providing any content that contravenes this agreement or any other relevant laws.',
  },
  {
    tag: 'p',
    text: "It's important to recognize that the Output Content is AI-generated and may be inaccurate or misleading. We do not guarantee its accuracy. You also acknowledge that similar inputs from different users may yield similar outputs.",
  },
  {
    tag: 'h2',
    text: 'V. Disclaimers of Warranties',
  },
  {
    tag: 'p',
    text: "Unless stated in these terms, our services are provided 'as is' without any guarantees. We do not promise uninterrupted or flawless use. Any implied warranties are only valid as stated in this agreement. We reserve the right to modify our services without notice.",
  },
  {
    tag: 'h2',
    text: 'VI. Limitation of Liability',
  },
  {
    tag: 'p',
    text: "Nothing in this agreement excludes or limits our responsibility for losses that cannot be lawfully waived. We are not liable for any loss of profit, goodwill, or data. Our liability is capped at the amount you've paid for our services in the last 12 months.",
  },
  {
    tag: 'p',
    text: 'We are not liable for damages due to third-party advertisements or relationships. Our platform is intended for personal use, and we are not responsible for any business-related losses. You are responsible for any mobile charges incurred while using our services.',
  },
  {
    tag: 'p',
    text: 'Any disputes you have with third parties related to your use of our services are between you and that party. We are exempt from any claims or damages arising from such disputes.',
  },
  {
    tag: 'h2',
    text: 'VII. Termination and Modification of the Services',
  },
  {
    tag: 'h3',
    text: '1.Termination and Interruption',
  },
  {
    tag: 'p',
    text: 'A. You may apply for termination of your Account at any time and for any reason by sending an application to our customer service team. The Company may terminate your Account and your access to the Services if the Company finds your application reasonable and acceptable. The Company is not obliged to provide the Services unless required by applicable law. Therefore, the Company may terminate the Services in its entirety, or any part thereof, without giving a reason, notice, and compensation to you. The Company is not required to provide you with any notice or warning prior to any such termination. You may, as the result of the termination, lose your Account and all information and data associated therewith, and the Company is under no obligation to compensate you for any such loss.',
  },
  {
    tag: 'p',
    text: 'B. The Company reserves the right to deny the access of any user to the Services without notice for any reason, including but not limited to a violation of the Terms. If you violate the Terms, the Company reserves the right to issue you a warning regarding the violation or immediately terminate or suspend any or all Accounts you have created using the Services. You agree that the Company needs not to provide you any notice before terminating or suspending your Account, but it may do so.',
  },
  {
    tag: 'p',
    text: 'C. You understand that we need to perform scheduled or unscheduled repairs and maintenance of the Services. If such situations cause an interruption of Services for a reasonable duration, we shall not bear any liability to you and/or to any third parties. However, we shall provide notice to you as soon as practicable.',
  },
  {
    tag: 'h3',
    text: '2.Modification',
  },
  {
    tag: 'p',
    text: 'The Company reserves the right to change, modify, reprice, or discontinue (temporarily or permanently) the Services or any part thereof, with or without notice to you. You have the right to discontinue the use of the Services if you do not agree to such changes to the Services or the Terms made by us. Continued use of the Services shall be deemed as an acceptance of such changes.',
  },
  {
    tag: 'h2',
    text: 'VIII. GOVERNING LAW AND DISPUTE RESOLUTION',
  },
  {
    tag: 'h3',
    text: '1. Governing Law',
  },
  {
    tag: 'p',
    text: 'By accepting the Terms or becoming a User, you agree that the laws of Switzerland, irrespective of your location, will govern the Terms and any dispute of any sort that might arise between you and Pink Swan.',
  },
  {
    tag: 'h3',
    text: '2. Dispute Resolution',
  },
  {
    tag: 'p',
    text: 'A. Any dispute, controversy, difference or claim arising out of or relating to the Terms, including the existence, validity, interpretation, performance, breach or termination thereof or any dispute regarding non-contractual obligations arising out of or relating to it shall be referred to and finally resolved by arbitration administered in Switzerland.',
  },
  {
    tag: 'p',
    text: 'B. The seat of arbitration shall be in Switzerland. The number of arbitrators shall be one. The arbitration proceedings shall be conducted in English.',
  },
  {
    tag: 'p',
    text: 'C. If the arbitration clauses above are determined to be totally invalid or non-enforceable, then any dispute, controversy, difference or claim arising out of or relating to the Terms shall be decided exclusively by a court of competent jurisdiction located in Switzerland.',
  },
  {
    tag: 'h3',
    text: '3.User Disputes',
  },
  {
    tag: 'p',
    text: 'You are solely responsible for your interaction with other users of the Services and other parties that you come in contact with through the Services. The Company hereby disclaims any and all liability to you or any third party relating to your use of the Service. The Company reserves the right, but has no obligation, to manage disputes between you and other users of the Services.',
  },
  {
    tag: 'h2',
    text: 'IX. Affiliation Program Terms and Conditions',
  },
  {
    tag: 'h3',
    text: '1.Definitions',
  },
  {
    tag: 'ul',
    items: [
      '- "Affiliate" refers to an individual or entity that has been accepted into the Affiliation Program and has been provided with a unique affiliate link.',
      `- "Affiliate Link" refers to the unique tracking link provided to the Affiliate for promoting Pink Swan's products or services.`,
      `- "Commission" refers to the amount payable to the Affiliate for each Qualified Purchase.`,
      `- "Company" refers to Pink Swan and its affiliated websites or applications.`,
      `- "Qualified Purchase" refers to a completed purchase made by a Referred Customer through the Affiliate Link, subject to the terms and conditions outlined herein.`,
      `- "Referred Customer" refers to a unique individual who makes a Qualified Purchase after clicking on the Affiliate Link.`,
    ],
  },
  {
    tag: 'h3',
    text: '2.Affiliate Obligations',
  },
  {
    tag: 'ul',
    items: [
      "- The Affiliate agrees to promote Pink Swan's products or services in a legal, ethical, and professional manner.",
      '- The Affiliate must disclose the affiliate relationship with Pink Swan in accordance with applicable laws and regulations.',
      "- The Affiliate shall not engage in any fraudulent, deceptive, or misleading practices, including but not limited to click fraud, self-referrals, or misrepresentation of Pink Swan's products or services.",
      '- The Affiliate shall not infringe upon any intellectual property rights of Pink Swan or any third party.',
    ],
  },
  {
    tag: 'h3',
    text: '3.Commission and Payment',
  },
  {
    tag: 'ul',
    items: [
      '- The Affiliate shall earn a Commission for each Qualified Purchase made by a Referred Customer.',
      '- The Commission rate and structure shall be determined by Pink Swan and communicated to the Affiliate.',
      '- Pink Swan reserves the right to modify the Commission rate and structure at any time, with prior notice to the Affiliate.',
      "- Commissions shall be paid to the Affiliate in accordance with Pink Swan's payout schedule and minimum payout threshold.",
      '- Pink Swan shall not be liable for any delays, failures, or errors in the tracking, recording, or payment of Commissions.',
    ],
  },
  {
    tag: 'h3',
    text: '4.Cookies and Tracking',
  },
  {
    tag: 'ul',
    items: [
      '- The Affiliation Program relies on the use of cookies to track and attribute Qualified Purchases to the Affiliate.',
      '- The Affiliate acknowledges that if a Referred Customer has blocked the use of cookies on their browser, Pink Swan will not be able to retrieve information about the application, and the Qualified Purchase cannot be tracked or attributed to the Affiliate.',
      "- Pink Swan shall not be liable for any loss of Commissions resulting from the Referred Customer's browser settings or use of ad-blocking technologies that prevent the use of cookies.",
    ],
  },
  {
    tag: 'h3',
    text: '5.Termination',
  },
  {
    tag: 'ul',
    items: [
      '- Either party may terminate the Affiliation Program agreement at any time, with or without cause, by providing written notice to the other party.',
      "- Upon termination, the Affiliate shall immediately cease all promotion of Pink Swan's products or services and remove any Affiliate Links from their websites or marketing materials.",
      '- Pink Swan reserves the right to withhold or forfeit any unpaid Commissions if the Affiliate is found to be in violation of these terms and conditions.',
    ],
  },
  {
    tag: 'h3',
    text: '6.Limitation of Liability',
  },
  {
    tag: 'ul',
    items: [
      '- Pink Swan shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with the Affiliation Program.',
      "- Pink Swan's total liability under this agreement shall not exceed the total Commissions paid to the Affiliate in the preceding six (6) months.",
    ],
  },
  {
    tag: 'h3',
    text: '7.Governing Law and Jurisdiction',
  },
  {
    tag: 'ul',
    items: [
      '- These terms and conditions shall be governed by and construed in accordance with the laws of Switzerland.',
      '- Any disputes arising out of or in connection with the Affiliation Program shall be subject to the exclusive jurisdiction of the courts of Switzerland.',
    ],
  },
  {
    tag: 'h2',
    text: 'X. GDPR COMPLIANCE',
  },
  {
    tag: 'p',
    text: 'We value your privacy and are committed to ensuring that your personal data is handled in a secure and responsible manner. As part of our commitment to protecting your personal information, we comply with the General Data Protection Regulation (GDPR), which governs the collection, use, and protection of personal data within the European Union (EU).',
  },
  {
    tag: 'h3',
    text: 'Data Collection & Use',
  },
  {
    tag: 'p',
    text: 'We collect and process personal data only for specific, legitimate purposes, and in a manner that is transparent to you. The data we collect is used solely to provide and improve our services, communicate with you, and comply with legal obligations.',
  },
  {
    tag: 'h3',
    text: 'Your Rights Under GDPR',
  },
  {
    tag: 'p',
    text: 'Under GDPR, you have several rights regarding your personal data, including:',
  },
  {
    tag: 'ul',
    items: [
      '- Right to Access: You can request access to your personal data that we hold.',
      '- Right to Rectification: You can request correction of any inaccurate or incomplete data.',
      '- Right to Erasure (Right to be Forgotten): You can request the deletion of your personal data when it is no longer necessary for the purposes for which it was collected.',
      '- Right to Restrict Processing: You can request the restriction of processing your data under certain conditions.',
      '- Right to Data Portability: You can request that we provide your personal data in a structured, commonly used, and machine-readable format.',
      '- Right to Object: You can object to the processing of your personal data in certain circumstances, including direct marketing.',
      '- Right to Lodge a Complaint: If you believe that your data rights have been violated, you can file a complaint with a supervisory authority in the EU.',
    ],
  },
  {
    tag: 'h3',
    text: 'Data Protection Measures',
  },
  {
    tag: 'p',
    text: 'We have implemented technical and organizational measures to protect your personal data from unauthorized access, disclosure, alteration, and destruction. These measures include encryption, regular security audits, and employee training on data protection best practices.',
  },
  {
    tag: 'h3',
    text: 'Third-Party Data Sharing',
  },
  {
    tag: 'p',
    text: 'We do not sell or rent your personal data to third parties. However, we may share your data with trusted third-party service providers that help us operate our services, but only as necessary and under strict data protection agreements.',
  },
  {
    tag: 'h3',
    text: 'Data Transfers Outside the EU',
  },
  {
    tag: 'p',
    text: 'If your personal data is transferred outside the European Economic Area (EEA), we ensure that appropriate safeguards are in place to protect your data in accordance with GDPR requirements.',
  },
  {
    tag: 'h3',
    text: 'Contact Us',
  },
  {
    tag: 'p',
    text: 'If you have any questions about how we handle your personal data or wish to exercise your rights under GDPR, please contact us at contact@louisebot.com .',
  },
  {
    tag: 'h2',
    text: 'XI. MISCELLANEOUS',
  },
  {
    tag: 'h3',
    text: 'Entire Agreement',
  },
  {
    tag: 'p',
    text: 'These Terms constitute the whole legal agreement between you and the Company and govern your use of the Services and completely replace any prior agreements between you and the Company in relation to the Services.',
  },
  {
    tag: 'h3',
    text: 'Links',
  },
  {
    tag: 'p',
    text: 'You may link to our home page, provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it. You must not establish a link in such a way as to suggest any form of association, approval, or endorsement on our part where none exists. You must not establish a link to our Services in any website that is not owned by you. The website in which you are linking must comply in all respects with the content standards set out in the Terms. We reserve the right to withdraw linking permission without notice.',
  },
  {
    tag: 'h3',
    text: 'No Waiver',
  },
  {
    tag: 'p',
    text: 'Our failure to insist upon or enforce any provision of these Terms shall not be construed as a waiver of any provision or right.',
  },
  {
    tag: 'h3',
    text: 'Security',
  },
  {
    tag: 'p',
    text: 'Security. We do not guarantee that our Services will be secure or free from bugs or viruses. You are responsible for configuring your information technology, computer programs, and platform to access our Services. You should use your own virus protection software.',
  },
  {
    tag: 'h3',
    text: 'Severability',
  },
  {
    tag: 'p',
    text: ' If any court of law, having jurisdiction to decide on this matter, rules that any provision of these Terms is invalid, then that provision will be removed from the Terms without affecting the rest of the Terms, and the remaining provisions of the Terms will continue to be valid and enforceable.',
  },
  {
    tag: 'h3',
    text: 'Headings',
  },
  {
    tag: 'p',
    text: 'The section headings used herein are for convenience only and shall not be given any legal import. Upon the Company’s request, you will furnish the Company with any documentation, substantiation, or releases necessary to verify your compliance with the Terms.',
  },
  {
    tag: 'h3',
    text: 'Survival',
  },
  {
    tag: 'p',
    text: 'You agree that the provisions of the Terms that by their nature should survive termination will survive any termination of these Terms.',
  },
  {
    tag: 'h3',
    text: 'Class Action Waiver',
  },
  {
    tag: 'p',
    text: " Any Claim must be brought in the respective party’s individual capacity, and not as a plaintiff or class member in any purported class, collective, representative, multiple plaintiffs, or similar proceeding (“Class Action”). The parties expressly waive any ability to maintain any Class Action in any forum. If the Claim is subject to arbitration, the arbitrator will not have authority to combine or aggregate similar claims or conduct any Class Action nor make an award to any person or entity not a party to the arbitration. Any claim that all or part of this Class Action Waiver is unenforceable, unconscionable, void, or voidable may be determined only by a court of competent jurisdiction and not by an arbitrator. The parties understand that any right to litigate in court, to have a judge or jury decide their case, or to be a party to a class or representative action, is waived, and that any claims must be decided individually, through arbitration. If this class action waiver is found to be unenforceable, then the entirety of the Arbitration Agreement, if otherwise effective, will be null and void. The arbitrator may award declaratory or injunctive relief only in favor of the individual party seeking relief and only to the extent necessary to provide relief warranted by that party's individual claim. If for any reason a claim proceeds in court rather than in arbitration, you and the Company each waive any right to a jury trial.",
  },
  {
    tag: 'h3',
    text: 'Third-Party Services and Rights',
  },
  {
    tag: 'p',
    text: 'We use third-party services to help us provide LouiseBot, but such use does not indicate that we endorse them or are responsible or liable for their actions. By accessing or using LouiseBot, you are also agreeing to be bound by any applicable third-party Terms of Service. Additionally, LouiseBot may link to third-party websites to facilitate its provision of services to you. If you use these links, you will leave LouiseBot. Some of these third-party websites may use our materials under license from us. Pink Swan is not responsible for nor does it endorse these third-party websites or the organizations sponsoring such third-party websites or their products or services, whether or not we are affiliated with such third-party websites. You agree that Pink Swan is not responsible or liable for any loss or damage of any sort incurred as a result of any such dealings you may have on or through a third-party website or as a result of the presence of any third-party advertising on LouiseBot.',
  },
  {
    tag: 'h3',
    text: 'International Use and Export Control',
  },
  {
    tag: 'p',
    text: 'The Terms may appear in different languages. If any discrepancy or inconsistency occurs between the versions of different languages, this English version shall always prevail. Downloading or using the software is at your sole risk. You hereby represent and warrant that (i) you are not located in a country that is subject to a U.S. government embargo, or that has been designated by the U.S. government as a “terrorist supporting” country; (ii) You are not listed on any U.S. government list of prohibited or restricted parties. Recognizing the global nature of the Internet, you agree to comply with all local rules and laws regarding your use of the Service, including as it concerns online conduct and acceptable content. Particularly, you may not use or otherwise export or re-export the Services and its components except as authorized by the United States (“U.S.”) law and the laws of the jurisdiction in which the Services were obtained. The software and applications comprise the Services may not be exported or re-exported into any U.S.-embargoed countries or to anyone on the U.S. Treasury Department’s Specially Designated Nationals List or the U.S. Department of Commerce Denied Persons List or Entity List. By accessing and using the Services, you represent and warrant that you are not located in any such country or on any such list. You also agree that you will not use these products for any purposes prohibited by U.S. law, including, without limitation, the development, design, manufacture, or production of the nuclear, missile, or chemical or biological weapons.',
  },
  {
    tag: 'h3',
    text: 'Assignment',
  },
  {
    tag: 'p',
    text: 'The Company may assign, transfer, novate, part with or subcontract any of its rights, responsibilities and/or obligations under these Terms (in whole or in part) to its affiliate(s) without your prior consent. The Company may assign these Terms to an acquirer of all or substantially all of the business related to the Platform and/or Services, whether directly or indirectly by merger, share purchase, asset acquisition, operation of law, or otherwise, without your prior consent. You shall not assign or transfer or purport to assign or transfer the contract between you and us to any other person.',
  },
  {
    tag: 'h3',
    text: 'Contact Us',
  },
  {
    tag: 'p',
    text: 'You can reach us at contact@louisebot.com',
  },
];
